import React from 'react';
import { createRoot } from 'react-dom/client';
import Sara from './Sara';
import './scss/styles.scss';
import { Provider } from 'react-redux';
import store, { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';

/**
 * Base component for the application
 * @description - Wrapping the `Sara` component in the Redux provider component as well as the redux-persist component to allow for local storage of Redux information. It is necessary to wrap the `Sara` component this way due to conflicts with the internationalization framework if the Provider and PersistGate are used directly in the `Sara` component
 */

// React 18 root rendering pattern
const container = document.getElementById('root');

// Only render if we're in a browser environment (not during tests)
if (container) {
  const root = createRoot(container);
  
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Sara data-test="component-sara" />
      </PersistGate>
    </Provider>
  );
}